export const AWS_S3: string =
    'https://automotive-api.s3.us-east-2.amazonaws.com/';
